<template>
  <div class="relative sm:col-span-6 text-green-400 font-medium">
    <div class="flex sm:col-span-6 text-green-400 font-medium">
        <span>
            {{ subheadline }}
        </span>
      <hr class="flex-1 mt-3 mx-2"/>
      <i v-if="showInfo" class="fas fa-question-circle mt-1 cursor-pointer text-gray-300"
         @click="showHelptext = true">
      </i>
    </div>

<!--    desktop-->
    <div v-if="showHelptext"
         class="hidden sm:block absolute z-10 px-8 pb-8 pt-4 w-2/5 right-0 bg-green-50 text-green-500 text-sm rounded-md 2xl:right-[-337px]">
      <HelpText v-model:showHelptext="showHelptext"
                :helptext-headline="helptextHeadline"
                :helptext="helptext"
                :helptext-headline-two="helptextHeadlineTwo"
                :helptext-two="helptextTwo"
      />
    </div>

<!--    mobile-->
    <div v-if="showHelptext"
         class="sm:hidden block w-full h-full absolute z-10 px-8 pb-8 pt-4  bottom-0 left-0 bg-green-50 text-green-500 text-sm rounded-md"
         :class="{ slideUp: showHelptext }">
      <HelpText v-model:showHelptext="showHelptext"
                :helptext-headline="helptextHeadline"
                :helptext="helptext"
                :helptext-headline-two="helptextHeadlineTwo"
                :helptext-two="helptextTwo"
      />
    </div>
  </div>
</template>

<script setup>
import HelpText from "./HelpText";
import {ref} from "vue";

defineProps({
  subheadline: String,
  date: String,
  showInfo: {
    type: Boolean,
    default: true,
  },
  helptextHeadline: String,
  helptextHeadlineTwo: String,
  helptext: String,
  helptextTwo: String,
})

const showHelptext = ref(false);

</script>
